<template>
  <v-list-group
    no-action
    :subgroup="subGroup"
    :prepend-icon="prependedIcon"
  >
    <template #activator="{ props }">
      <v-list-item v-bind="props" :title="item.title" nav />
    </template>

    <div v-show="item.items.length > 0">
      <template
        v-for="(menuItem, index) in item.items"
      >
        <MenuItem
          v-if="menuItem.type === 'I'"
          :key="`${index}-item`"
          :icon="menuItem.icon"
          :label="menuLabel(menuItem.title)"
          :route="menuItem.route"
          :style="styles(32)"
          link
        />

        <MenuGroup
          v-else-if="menuItem.type === 'M'"
          :key="`${index}-menu`"
          :item="menuItem"
          :indentLevel="indentLevel + 32"
          :style="styles"
          subGroup
        />

        <v-divider v-else-if="menuItem.type === 'D'" :key="index" />
      </template>
    </div>
  </v-list-group>
</template>

<script>
import MenuItem from './MenuItem.vue';

/**
 * Represents a group of MenuItems within the Menu component.
 * @vue-prop {Object} [item = null] - Item representing a menu group.
 * @vue-prop {Boolean} [subGroup = false] -  Indicates that there is a subgroup.
 */
export default {
  name: 'MenuGroup',
  components: { MenuItem },

  props: {
    item: {
      type: Object,
      default: null,
    },
    subGroup: {
      type: Boolean,
      default: false,
    },
    indentLevel: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    prependedIcon() {
      if (this.item.icon && !this.subGroup) return this.item.icon;
      return null;
    },
  },

  methods: {
    /**
     * Label to used when for MenuItem label.
     * @param {String} title - Title to lookup label against.
     * @return {String} - Label for corresponding passed title.
     */
    menuLabel(title) {
      return this.$store.getters['menu/menuLabel'](title);
    },

    styles(padding = 0) {
      return {
        paddingInlineStart: `${this.indentLevel + padding}px !important`,
      };
    },
  },
};
</script>


<style lang="scss">
  .v-list-group--active .v-list-group__items div .v-list-group--active {
    background-color: #F5F5F5;
  }
</style>
